export default {
  community: "Community",
  fansOf: "Fans of",
  nationalsCardButtonText: "Visit Forum",
  nationalsTeamSelectorTitle: "What's your team saying?",
  nationalsTitle: "Fans are talking",
  siteCardsButtonText: "Join the Discussion"
};
